import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { BasePageComponent } from '../../base-page.component';
import { Inspection, Person } from '../../shared/models/index';
import { InspectionService, PeopleService, AccessRightsService } from '../../shared/services/index';
import { ActivatedRoute, Router, Params } from '@angular/router';

@Component({
    selector: 'inspection-collaborate',
    templateUrl: 'collaborate.component.html',
    standalone: false
})
export class InspectionCollaboratePageComponent extends BasePageComponent implements OnInit {
  public inspection: Inspection;
  public inspectionId: string;
  public processing = false;
  public columns: string[] = ['Read', 'Write'];
  public people: Person[];
  public accessRights: any[];

  constructor(
    location: Location,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private inspectionService: InspectionService,
    private peopleService: PeopleService,
    private accessRightsService: AccessRightsService
  ) {
    super(location);
  }

  ngOnInit() {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) {
        this.router.navigate([this.actionPlansRoute]);
      }
      this.inspectionId = id;

      this.inspectionService.getInspection(this.inspectionId).subscribe((data) => {
        this.inspection = data;
      });

      this.peopleService.getPeople().subscribe((data) => {
        this.people = data;
      });

      this.accessRightsService.getRights('inspections', this.inspectionId).subscribe((data) => {
        this.accessRights = data;
      });
    });
  }

  save(accessRights: any) {
    this.processing = true;
    this.accessRightsService.updateRights('inspections', this.inspectionId, accessRights).subscribe((el) => {
      this.processing = false;
      this.goToBack();
    });
  }

  cancel(): void {
    this.goToBack();
  }
}
